import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";


export const trunkwithrack = type => {
  document.title = 'ラック付きトランクルーム｜トランクルームをお探しなら『ハローストレージ』【公式】';

	let wrapper = {
		backgroundColor: "#fff"
	};
	
	return (
		<div>
				<div className="contents" style={wrapper}>
					<div id="firstview" className="firstview">
							<div className="firstview-img">
									<h1>
											<img className="pc-show" src="resource/img/static/trunkwithrack/fv_pc.png" alt="ラック販売・組み立てサービス"/>
											<img className="sp-show" src="resource/img/static/trunkwithrack/fv_sp.png" alt="ラック販売・組み立てサービス"/>
									</h1>
							</div>
					</div>

					<section id="about" className="about">
							<div className="container">
									<h2 className="pc-show"><img src="resource/img/static/trunkwithrack/catch_pc.svg" alt="お客様のご利用開始前にハローストレージが搬入・組み立てまで済ませておきます！"/></h2>
									<h2 className="sp-show"><img src="resource/img/static/trunkwithrack/catch_pc.svg" alt="お客様のご利用開始前にハローストレージが搬入・組み立てまで済ませておきます！"/></h2>
									<h3 className="merit pc-show"><img src="resource/img/static/trunkwithrack/merit_pc.png" alt="トランクルーム使い始め前の手間や不安を解決、お部屋を開けたらもう置いてある！"/></h3>
									<h3 className="merit sp-show"><img src="resource/img/static/trunkwithrack/merit_sp1.png" alt="トランクルーム使い始め前の手間や不安を解決"/></h3>
									<h3 className="merit sp-show"><img src="resource/img/static/trunkwithrack/merit_sp2.png" alt="お部屋を開けたらもう置いてある！"/></h3>
							</div>
					</section>
					<section id="service" className="service">
							<div className="container">
									<h3 className=""><img src="resource/img/static/trunkwithrack/service-title.svg" alt="サービス概要"/></h3>
									<div className="row">
											<div className="col-12">
													<div className="service-text pc-show"><img src="resource/img/static/trunkwithrack/service-text_pc.svg" alt=""/></div>
													<div className="service-text sp-show"><img src="resource/img/static/trunkwithrack/service-text_sp.svg" alt=""/></div>
											</div>
									</div>
							</div>
					</section>
					<section id="lineup" className="lineup">
							<div className="container">
									<h3 className=""><img src="resource/img/static/trunkwithrack/lineup-title.svg" alt="商品ラインナップ"/></h3>
									<div className="row">
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup01.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup02.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup03.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup04.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup05.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup06.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup07.png" alt=""/></p>
											</div>
											<div className="col-6 col-lg-4">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup08.png" alt=""/></p>
											</div>
									</div>
									<div className="row">
											<div className="col-lg-8 offset-lg-2">
													<p className="lineup-img"><img src="resource/img/static/trunkwithrack/lineup10.png" alt=""/></p>
											</div>
									</div>
							</div>
					</section>
					<section id="apply" className="apply">
							<div className="container">
									<div className="row">
											<div className="col-12">
													<h3><img src="resource/img/static/trunkwithrack/apply-title.svg" alt="申し込み方法"/></h3>
													<h4><img src="resource/img/static/trunkwithrack/apply-catch.svg" alt="トランクルーム物件を新規契約の際にお申し込みください。"/></h4>
											</div>
									</div>
									<div className="row howto-apply-case" style={{"padding-bottom": "60px", "margin-bottom": "60px", "border-bottom": "dotted #999"}}>
											<div className="col-12 col-lg-4">
													<p className="howto-net pc-show"><img src="resource/img/static/trunkwithrack/howto-net.svg" alt="ネットで申し込み"/></p>
													<p className="howto-net sp-show"><img src="resource/img/static/trunkwithrack/howto-net_sp.svg" alt="ネットで申し込み"/></p>
											</div>
											<div className="col-12 col-lg-8">
													<p className="howto-net-text"><img src="resource/img/static/trunkwithrack/howto-net-text.svg" alt="契約内容の確認画面にて、「お片付けコンシェルジュ申込」 をお選びいただき、ご契約へと進んでください。"/></p>
													<p className="howto-net-img pc-show"><img src="resource/img/static/trunkwithrack/howto-net-img_pc.png" alt="契約内容の確認画面"/></p>
													<p className="howto-net-img sp-show"><img src="resource/img/static/trunkwithrack/howto-net-img_sp.png" alt="契約内容の確認画面"/></p>
											</div>
									</div>
									<div className="row">
											<div className="col-12 col-lg-4">
													<p className="howto-tel pc-show"><img src="resource/img/static/trunkwithrack/howto-tel.svg" alt="お電話で申し込み"/></p>
													<p className="howto-tel sp-show"><img src="resource/img/static/trunkwithrack/howto-tel_sp.svg" alt="お電話で申し込み"/></p>
											</div>
											<div className="col-12 col-lg-8">
													<p className="howto-tel-text"><img src="resource/img/static/trunkwithrack/howto-tel-text.svg" alt="オペレーターに「お片付けコンシェルジュ申込希望」とお伝えください。"/></p>
											</div>
									</div>
									<div className="row howto-notes">
											<div className="col-12">
													<p className="howto-notes-title">【注意事項】</p>
													<ul className="howto-notes-ul">
															<li>①ラック販売・組み立てサービスをご利用希望の場合、最短の利用開始日は、4日後となります。</li>
															<li>②ご解約の際には、お客様ご自身でラックの解体・撤去を行っていただく必要がございます。</li>
															<li>③ラック購入希望はお申し込み時にのみ承ります。弊社ホームページもしくはコールセンターでのお申し込み時にご選択ください。</li>
															<li>④ラック購入費用は、初期費用と合わせてお支払いください。</li>
															<li>⑤ラックは組み立てた状態でご利用開始日までに室内に搬入いたします。</li>
															<li>⑥商品に欠陥がある場合を除き、返品には応じません。予めご了承ください。</li>
															<li>⑦ラック組立後の故障や故障に伴う収納物の破損については一切責任を負いかねますのでご了承ください。</li>
															<li>⑧収納以外の用途ではご利用を絶対に行わないでください。</li>
													</ul>
											</div>
									</div>
							</div>
					</section>
					<section id="fixed-trunk" className="fixed-trunk">
							<div className="container">
									<h3 className=""><img src="resource/img/static/trunkwithrack/fixed-title.svg" alt="ラック備え付けトランクルームも展開中"/></h3>
									<div className="row">
											<div className="col-xs-12 col-lg-6">

													<div className="rackInnner">
															<h2 className="racktitle">固定式ラックシリーズ</h2>
															<p><img src="resource/img/static/trunkwithrack/ko_rack.png" alt="固定式ラックシリーズ"/></p>
															<div className="ac-box">
																	<input id="ac-1" name="accordion-1" type="checkbox" />
																	<label for="ac-1"> 対象物件一覧 </label>
																	<div className="ac-small">
																			<ul className="compartments__list">
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/chiba/funabashishi/detail/5980/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 高根公団</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/adachiku/detail/6092/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 千住大橋</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/suginamiku/detail/5834/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 下井草</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/fuchushi/detail/5996/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 府中本宿町</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/chofushi/detail/6111/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 調布多摩川</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/saitama/koshigayashi/detail/5842/"
																									className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 埼玉・南越谷</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/itabashiku/detail/6028/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 板橋中丸町</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/chiba/ichikawashi/detail/6195/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 市川広小路</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/chiba/urayasushi/detail/5984/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 浦安</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/mitakashi/detail/6296/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 三鷹深大寺</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/kanagawa/kawasakishi/tamaku/detail/6156/"
																									className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 多摩区役所前</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/meguroku/detail/6218/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 目黒本町</span>
																							</a>
																					</li>
																			</ul>
																	</div>
															</div>
													</div>
													<h2 className="inner-title">注意事項</h2>
													<ul className="notes__list">
															<li className="notes__list-item">
																	<p className="text">◎ご使用中のラックの撤去および移動はできません。<br/>あらかじめご了承ください。</p>
															</li>
															<li className="notes__list-item">
																	<p className="text">◎お部屋ごとにラックの寸法は異なります。<br/>詳細な寸法は物件ごとにご確認ください。</p>
															</li>
													</ul>
											</div>
											<div className="col-xs-12 col-lg-6">
													<div className="rackInnner">
															<h2 className="racktitle">可変式ラックシリーズ</h2>
															<p><img src="resource/img/static/trunkwithrack/ka_rack.png" alt="可変式ラックシリーズ"/></p>
															<div className="ac-box">
																	<input id="ac-2" name="accordion-1" type="checkbox" />
																	<label for="ac-2"> 対象物件一覧 </label>
																	<div className="ac-small">
																			<ul className="compartments__list">
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/setagayaku/detail/6059/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 世田谷中町</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/adachiku/detail/6092/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 千住大橋</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/itabashiku/detail/6217/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 板橋蓮根</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/chiba/ichikawashi/detail/6295/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 市川行徳</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/suginamiku/detail/6290/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 杉並堀ノ内</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/suginamiku/detail/6212/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 杉並阿佐ヶ谷</span>
																							</a>
																					</li>
																					<li className="compartments__list-item">
																							<a href="https://www.hello-storage.com/tokyo/shinagawaku/detail/6221/" className="compartments__link">
																									<span className="compartments__link-inner">ハローストレージ 南品川</span>
																							</a>
																					</li>
																			</ul>
																	</div>
															</div>
													</div>
													<h2 className="inner-title">注意事項</h2>
													<ul className="notes__list">
															<li className="notes__list-item">
																	<p className="text">◎共有部に持ち出して利用しないでください。</p>
															</li>
															<li className="notes__list-item">
																	<p className="text">◎台車本体の最大積載荷重は500kgです。</p>
															</li>
															<li className="notes__list-item">
															<p className="text">◎詳細については<a href="https://www.hello-storage.com/resource/img/static/trunkwithrack/notes.png" target="_blank" rel="noopener noreferrer" style={{display: "inline-block", color: "#007bff", "text-decoration": "underline"}}>こちら</a>をご確認ください。</p>
															</li>
													</ul>
											</div>
									</div>
							</div>
					</section>
			</div>

			<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous"></link>
			<script src="https://code.jquery.com/jquery-3.5.1.slim.min.js" integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj" crossorigin="anonymous"></script>
			<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js" integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN" crossorigin="anonymous"></script>
			<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js" integrity="sha384-B4gt1jrGC7Jh4AgTPSdUtOBvfO8shuf57BaghqFfPlYxofvL8/KUEfYiJOMMV+rV" crossorigin="anonymous"></script>
		</div>
	);
};



// WEBPACK FOOTER //
// ./pages/static/trunkwithrack.jsx